import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "flightRouteSelect",
    "routeSelectWrapper",
    "flightDate",
    "departureAirport",
    "arrivalAirport"
  ]
  static values = { flightRoutes: Array }

  connect() {
    this.flightRoutes = this.flightRoutesValue
  }

  flightRouteChanged(event) {
    const selectedFlightRouteId = event.target.value

    if (selectedFlightRouteId) {
      const flightRoute = this.flightRoutes.find(route => route.id === selectedFlightRouteId)

      if (flightRoute) {
        // Always update airport codes when flight route changes
        this.setSelectValue(this.departureAirportTarget, flightRoute.provisioning_airport_code)
        this.setSelectValue(this.arrivalAirportTarget, flightRoute.offloading_airport_code)
      }
    }
  }

  setSelectValue(selectElement, value) {
    // Set the underlying select value
    selectElement.value = value
    selectElement.dispatchEvent(new Event('change', { bubbles: true }))

    // Update Choices.js visual display if present
    const choicesContainer = selectElement.closest('.choices')
    if (choicesContainer) {
      const choicesInner = choicesContainer.querySelector('.choices__inner')
      const selectedOption = selectElement.querySelector(`option[value="${value}"]`)

      if (choicesInner && selectedOption) {
        const existingItem = choicesInner.querySelector('.choices__item--selectable')
        if (existingItem) {
          existingItem.textContent = selectedOption.textContent
          existingItem.setAttribute('data-value', value)
        }

        // Trigger visual refresh
        setTimeout(() => {
          selectElement.focus()
          selectElement.blur()
        }, 10)
      }
    }
  }

  departureAirportChanged(event) {
    this.suggestFlightRoute()
  }

  arrivalAirportChanged(event) {
    this.suggestFlightRoute()
  }

  suggestFlightRoute() {
    const departureCode = this.departureAirportTarget.value
    const arrivalCode = this.arrivalAirportTarget.value

    if (departureCode && arrivalCode && !this.flightRouteSelectTarget.value) {
      const matchingRoute = this.flightRoutes.find(route =>
        route.provisioning_airport_code === departureCode &&
        route.offloading_airport_code === arrivalCode
      )

      if (matchingRoute) {
        this.setSelectValue(this.flightRouteSelectTarget, matchingRoute.id)
      }
    }
  }

}
